import styled from 'styled-components'

export const GlobalTable = styled.table`
  height: 100%;
  width: 100%;
  text-align: start;
  border-collapse: collapse;
  
  tr:nth-child(2) td:first-child {
    border-top-left-radius: .5rem;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: .5rem;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: .5rem;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: .5rem;
  }

  tr:last-child{
    border:none
  }
`

export const HeaderLine = styled.tr`
  position: sticky;
  top: 0;
  height: 4rem;
  z-index: 1;
`

export const ConfigButton = styled.button`
  position: absolute;
  height: 100%;
  right: 0;
  outline: none;
  color: #C0C0C0;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: rgba(0, 0, 0, 0);
`

export const Th = styled.th`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: .85rem;
  font-weight: 400;
  padding-left: 1.2rem;
`

export const Tr = styled.tr`
  height: 4.5rem;
  background-color:#fff;
  border-bottom: solid 1px #ebebeb;
  border-radius: 1rem;
  
  &.yellowLine{
    background-color: #FFFCEE;
    color: #9D7D07;
    &:hover{
      background-color:rgba(229, 213, 140, 0.34);
    }
  }

  &.greenLine{
    background-color: #E8F7EC;
    color:rgba(97, 204, 122, .5);
    &:hover{
      background-color:#F7F7F7;
    }
  }
  
  &:hover{
    background-color:#F7F7F7;
    
    .edit-div{
      visibility:visible;
    }
  }
`

export const Td = styled.td`
  width: 20rem;
  text-align: start;
  font-size: 14px;
  padding-left: 1.2rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const DivInTd = styled.div`
  display:flex;
  gap:0.3rem;
  align-items:center;

  .documentUrl {
    cursor:pointer;
    &:hover {
    color: #0090d3;
    }
  }
`

export const TdButtons = styled.td`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: fit-content;
  padding-right: 1rem;
  img{
    cursor: pointer;
  }
`

export const LoadMoreButton = styled.button`
  width: fit-content;
  padding: .5rem 1rem;
  color: #0090D3;  
  background-color: #fff;
  outline: none;
  border: 1px solid #0090D3;
  border-radius: 2rem;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  margin: 1rem auto;
  cursor: pointer;
  display: flex;
  gap: .5rem;
  align-items: center;
`